module.exports = __webpack_public_path__ + "assets/img/jili.5c11700e.png";